module.exports = __webpack_public_path__ + "img/1-3.3401b503.png";